/* Stylesheet */

.horizontal_boxplot_options {
  display: flex;
  align-items: center;
  gap: 12px;
}
